import { endPoints } from '../../../Config';
import { handleGetRequest } from '../../../service/GetTemplate';
import { handlePostRequest } from '../../../service/PostTemplate';
import { handlePatchRequest } from '../../../service/PatchTemplate';

export const getSiteInspections = (params, dispatch) =>
    handleGetRequest(endPoints.getSiteInspections(params), false, false, dispatch);

export const getSiteInspection = (id, dispatch) =>
    handleGetRequest(endPoints.getSiteInspection(id), false, false, dispatch);

export const createSiteInspection = (payload, dispatch) =>
    handlePostRequest(payload, endPoints.createSiteInspection, false, false)(dispatch);

export const updateSiteInspection = (id, payload, dispatch) =>
    handlePatchRequest(payload, endPoints.updateSiteInspection(id), false, false)(dispatch);
